export function getAriaSortValue(columnName, sortedBy, sortedAsc) {
    if (columnName !== sortedBy) {
        return "none";
    }
    return sortedAsc ? "ascending" : "descending";
}
